var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-group",
      class: { "has-error": _vm.errors.has("activity") }
    },
    [
      _c("label", { staticClass: "col-xs-12 col-sm-2 control-label" }, [
        _vm._v("Activity:")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-sm-10" }, [
        _c("div", { staticClass: "row activity-picker" }, [
          _c(
            "div",
            {
              class: [
                "dropdown-container col-xs-12 col-sm-6",
                _vm.teEntryOption === _vm.TE_ENTRY_OPTIONS.BUILDTIME
                  ? "col-md-4"
                  : ""
              ]
            },
            [
              _c("custom-select", {
                ref: "vselect",
                attrs: {
                  options: _vm.activityOptions,
                  "on-change": _vm.onActivitySelectionChange,
                  clearSearchOnSelect: true,
                  value: _vm.selectedActivity,
                  loading: _vm.loading,
                  disabled:
                    _vm.$store.getters.restrictedEditMode ||
                    _vm.$store.state.timeEntry.isAuditEdit,
                  selectOnTab: true
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.teEntryOption === _vm.TE_ENTRY_OPTIONS.BUILDTIME &&
          _vm.selectedActivity &&
          _vm.showTargets
            ? _c("div", { staticClass: "col-xs-12 col-sm-12 col-md-8" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "label",
                        { staticClass: "col-xs-12 col-sm-3 control-label" },
                        [_vm._v(_vm._s(_vm.targetDropdownLabel) + ":")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-9" },
                        [
                          _c("custom-select", {
                            ref: "vtarget",
                            attrs: {
                              options: _vm.targetOptions,
                              "on-change": _vm.onTargetSelectionChange,
                              clearSearchOnSelect: true,
                              value: _vm.selectedTarget,
                              loading: _vm.loadingTargets,
                              disabled:
                                _vm.$store.getters.restrictedEditMode ||
                                _vm.$store.state.timeEntry.isAuditEdit,
                              selectOnTab: true
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.selectedTarget && _vm.showRoles
                    ? _c("div", { staticClass: "col-xs-12 col-sm-6" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "label",
                            { staticClass: "col-xs-12 col-sm-3 control-label" },
                            [_vm._v("Who:")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-xs-12 col-sm-9" },
                            [
                              _c("custom-select", {
                                ref: "vrole",
                                attrs: {
                                  options: _vm.roleOptions,
                                  "on-change": _vm.onRoleSelectionChange,
                                  clearSearchOnSelect: true,
                                  value: _vm.selectedRole,
                                  loading: _vm.loadingRoles,
                                  disabled:
                                    _vm.$store.getters.restrictedEditMode ||
                                    _vm.$store.state.timeEntry.isAuditEdit,
                                  selectOnTab: true
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedCode
            ? _c("div", { staticClass: "col-xs-12" }, [
                _c("div", { staticClass: "selected-code" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v("Code: " + _vm._s(_vm.selectedCode))
                  ])
                ])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.errors.has("activity") || _vm.activityError
          ? _c("p", { staticClass: "text-danger" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.activityError || _vm.errors.first("activity")) +
                  "\n        "
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05db43c8", { render: render, staticRenderFns: staticRenderFns })
  }
}